var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GBanner',{attrs:{"image":("https://cdn.gogoout.com/collection/" + _vm.type + ".jpg"),"title":_vm.title}}),_c('div',{staticClass:"container my-12"},[_c('CollectionIndex',{attrs:{"query":_vm.query}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }